import { useMemo, useState } from 'react';
import { Account } from '../../../../types';
import { Text, TextSpan } from '../../../Atoms/Text';
import { Icon } from '../../../Atoms/Icon';
import { BasicAccountMultiSelect } from '../../../Compounds/BasicAccountMultiSelect';
import { DetailRow } from './DetailRow';

interface SubAccountsRowProps {
  subAccounts: Account[];
  selectedAccounts: Account[];
  editable: boolean;
  onSelect: (accounts: Account[] | null) => void;
}

export const SubAccountsRow = ({ subAccounts, selectedAccounts, editable, onSelect }: SubAccountsRowProps) => {
  const [showSubAccounts, setShowSubAccounts] = useState<boolean>(false);

  const displayAccounts = useMemo(() => {
    const selectedIdSet = new Set(selectedAccounts.map((acc) => acc.id));
    const selected: Account[] = [];
    const unselected: Account[] = [];
    for (const account of subAccounts) {
      (selectedIdSet.has(account.id) ? selected : unselected).push(account);
    }
    return [...selected, ...unselected];
  }, [subAccounts, selectedAccounts]);

  return (
    <DetailRow
      testId="detail-row-sub-accounts"
      label="Sub Accounts">
      {!showSubAccounts && selectedAccounts.length === 0 && (
        <div className="w-full">
          <TextSpan className="flex items-center space-x-2 text-indigo">
            <button
              type="button"
              className="text-sm"
              data-cy="new-attachment"
              onClick={() => setShowSubAccounts(true)}>
              <Icon
                type="plusIndigo"
                className="inline-block align-text-bottom mr-4"
              />
              Add Sub Accounts
            </button>
          </TextSpan>
        </div>
      )}
      {(showSubAccounts || !!selectedAccounts.length) && (
        <div className="w-full">
          {editable ? (
            <BasicAccountMultiSelect
              displayAccounts={displayAccounts}
              selectedAccounts={selectedAccounts}
              handleChange={(_e, value) => onSelect(value)}
              handleSelectAll={() => onSelect(subAccounts)}
              handleSelectNone={() => onSelect([])}
            />
          ) : (
            <Text
              className="font-sans font-normal w-full"
              size="sm">
              {selectedAccounts.map((acct) => acct.name).join(', ')}
            </Text>
          )}
        </div>
      )}
    </DetailRow>
  );
};
